<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="text-h6">
					<span>Detail Log Email</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="2" md="2">
							<div class="text-subtitle-1 font-weight-bold">Tanggal</div>
							<div class="pt-1">{{emailLogDetail.email_log_datetime | tanggaljam}}</div>
						</v-col>
						<v-col cols="4" md="4">
							<div class="text-subtitle-1 font-weight-bold">Pengirim</div>
							<div class="pt-1">{{emailLogDetail.email_log_from}}</div>
						</v-col>
						<v-col cols="4" md="4">
							<div class="text-subtitle-1 font-weight-bold">Tujuan</div>
							<div class="pt-1">{{emailLogDetail.email_log_to}}</div>
						</v-col>
						<v-col cols="2" md="2">
							<div class="text-subtitle-1 font-weight-bold">Platform</div>
							<div class="pt-1">{{emailLogDetail.email_log_platform}}</div>
						</v-col>
					</v-row>
					<v-row class="">
						<v-col cols="12" md="12">
							<v-list color="deep-purple lighten-5" class="pa-1" rounded>
								<v-list-item dense class="px-1 justify-center">
									<div class="font-weight-bold text-uppercase primary--text">Judul</div>
								</v-list-item>
							</v-list>
						</v-col>
						<v-col cols="12" md="12">
							<v-card class="mb-1 elevation-0">
								<v-textarea
									readonly
									hide-details
									outlined
									background-color="deep-purple lighten-5"
									:rows="subjectHeight"
									v-model="emailLogSubject"
								/>
							</v-card>
						</v-col>
						<v-col cols="12" md="12">
							<v-list color="deep-purple lighten-5" class="pa-1" rounded>
								<v-list-item dense class="px-1 justify-center">
									<div class="font-weight-bold text-uppercase primary--text">Isi</div>
								</v-list-item>
							</v-list>
						</v-col>
						<v-col cols="12" md="12">
							<v-card class="mb-1 elevation-0">
								<v-textarea
									readonly
									hide-details
									outlined
									background-color="deep-purple lighten-5"
									:rows="contentHeight"
									v-model="emailLogContent"
								/>
							</v-card>
						</v-col>
						<v-col cols="12" md="12">
							<v-list color="deep-purple lighten-5" class="pa-1" rounded>
								<v-list-item dense class="px-1 justify-center">
									<div class="font-weight-bold text-uppercase primary--text">Respon</div>
								</v-list-item>
							</v-list>
						</v-col>
						<v-col cols="12" md="12">
							<v-card class="mb-1 elevation-0">
								<v-textarea
									readonly
									hide-details
									outlined
									background-color="deep-purple lighten-5"
									:rows="responseHeight"
									v-model="emailLogResponse"
								/>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			singleSelect: false,
		}
	},
	computed:{
		...mapState('emailLog', ['emailLogDetail']),

		emailLogSubject(){
			return this.detailEmailLog.email_log_subject == undefined ? '' : this.detailEmailLog.email_log_subject
		},
		emailLogContent(){
			return this.detailEmailLog.email_log_content == undefined ? '' : this.detailEmailLog.email_log_content
		},
		emailLogResponse(){
			try {
				return this.detailEmailLog.email_log_response == undefined ? '' : JSON.stringify(JSON.parse(this.detailEmailLog.email_log_response), null, '\t')
			} catch(e) {
				return this.detailEmailLog.email_log_response == undefined ? '' : this.detailEmailLog.email_log_response
			}
		},
		subjectHeight(){
			return this.emailLogSubject.split(/\r\n|\r|\n/).length
		},
		contentHeight(){
			return this.emailLogContent.split(/\r\n|\r|\n/).length
		},
		responseHeight(){
			return this.emailLogResponse.split(/\r\n|\r|\n/).length
		},
	},
	created() {
	},
	props: {
		dialog: Boolean,
		detailEmailLog: Object,
	},
	methods :{
		hideDialog(){
			this.$emit('hideDialog')
		},
	}
};
</script>
